<template>
    <PopupRouterViewDetail label="Delivery Instruction Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Delivery Instruction" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="text" label="Delivery Order" :model="model.deliveryOrder.doNumber" />
						<!-- <app-input-combobox-autocomplete :options="deliveryOrders" optionsLabel="doNumber" optionsKey="id" label-cols-lg="12" label="Delivery Order" id="fieldset-delivery-order" size="sm" :model.sync="model.deliveryOrderId"   :selected="model.deliveryOrder != null ? model.deliveryOrder.doNumber : ''" @input="getDeliveryOrders" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryOrder" /> -->
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Delivery Instruction Number" :model="model.diNumber" />
						<app-input-datepicker  id="fieldset-di-create-date" label-cols-lg="12"  label="Created Date" size="sm" :model.sync="model.diCreateDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="false" :isEditable="false" />
						<!-- <app-input-textbox id="fieldset-po-no-customer" label-cols-lg="12"  label="PO No Customer" label-for="input-po-no-customer" size="sm" :model.sync="model.poNoCustomer"  @change="updateData"  :isUpdatable="false" :isEditable="false" /> -->
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datepicker  id="fieldset-di-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.diDeliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="false" :isEditable="false" />
						<app-label label-cols-lg="12" size="sm" type="text" label="Customer" :model="model.diCustomer.name" />
						<app-label label-cols-lg="12" size="sm" type="text" label="Destination" :model="model.destination.name" />
						<!-- <app-input-combobox-autocomplete :options="deliveryInstructionStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Delivery Instruction Status" id="fieldset-di-status" size="sm" :model.sync="model.diStatusId"   :selected="model.diStatus != null ? model.diStatus.name : ''" @input="getDeliveryInstructionStatuss" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDiStatus" /> -->
				</b-col>

            </b-row>
        </b-card>

        <!-- <b-card header="Destination Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="fieldset-di-customer" size="sm" :model.sync="model.diCustomerId"   :selected="model.diCustomer != null ? model.diCustomer.code : ''" @input="getCustomers" @change="onDiCustomerChange"  :isUpdatable="false" :isEditable="false"  />
						<app-input-combobox-autocomplete :options="partDestinations" optionsLabel="destination" optionsKey="id" label-cols-lg="12" label="Part Destination" id="fieldset-part-destination" size="sm" :model.sync="model.partDestinationId"   :selected="model.partDestination != null ? model.partDestination.destination : ''" @input="getPartDestinations" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPartDestination" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Destination" id="fieldset-destination" size="sm" :model.sync="model.destinationId"   :selected="model.destination != null ? model.destination.code : ''" @input="getCustomers" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDestination" />
						<app-label label-cols-lg="12" size="sm" label="Office Address Destination" :model="(model.destination != null) ? model.destination.officeAddress : null"  />
				</b-col>

            </b-row>
        </b-card> -->

		<app-table-input-popup title="Delivery Instruction Details" :bordered="true" :items="deliveryInstructionDetails" :fields="fieldsDeliveryInstructionDetail" :busy="isDataLoading" :sort-by.sync="sortByDeliveryInstructionDetail" :sort-desc.sync="sortDescDeliveryInstructionDetail" small responsive
			@editButtonMethod="editRowDataDeliveryInstructionDetail"
			@deleteButtonMethod="deleteRowDataDeliveryInstructionDetail"
			@showPopupAddMethod="resetDataDeliveryInstructionDetail()"
			@showPopupUploadMethod="showPopupUploadDeliveryInstructionDetail()"
			@downloadMethod="downloadDeliveryInstructionDetail()"
			@addFromClipboardMethod="addFromClipboardDeliveryInstructionDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardDeliveryInstructionDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="false"
			>
			<template #top-row v-if="isShowDeliveryInstructionDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Part">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterDeliveryInstructionDetail.partId" :reduce="item => item.id" v-model="filterDeliveryInstructionDetail.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Delivery">
					<b-form-input id="input-qty-delivery-table" v-model="filterDeliveryInstructionDetail.qtyDelivery" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:head(front-action)>
				<div class="d-flex justify-content-center ml-2" v-if="true">
					<b-form-checkbox id="input-is-checked-all" @change="toggleSelectAll" :checked="checkAll"></b-form-checkbox>
				</div>
			</template>
			<template v-slot:cell(front-action)="row">
				<div class="d-flex justify-content-center ml-2" v-if="true">
					<b-form-checkbox :key="row.index" :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
				</div>
			</template>
			<template v-slot:cell(printAction)="row">
				<b-button @click="printDc(row.item.id)" variant="outline-success">Print DC</b-button>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( deliveryInstructionDetailPageSize * (currentDeliveryInstructionDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-delivery-instruction-details-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputDeliveryInstructionDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
				<!-- <app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  /> -->
				<app-input-textbox :id="'input-delivery-instruction-details-part-name-' + row.index " label-cols-lg="12" label="Part Name" size="sm" :model="(row.item.part != null) ? row.item.part.partName : null" :isUpdatable="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(qtyDelivery)="row">
				<app-input-textbox :id="'input-delivery-instruction-details-qty-delivery-' + row.index" label-cols-lg="12" label="Qty Delivery" size="sm" :model.sync="row.item.qtyDelivery"   @change="saveInputDeliveryInstructionDetail(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<DeliveryInstructionDetailInput 
					:openPopup="isShowPopupDeliveryInstructionDetail"
					:modelId="deliveryInstructionDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataDeliveryInstructionDetail"/>
			</template>
			<template v-slot:upload-detail>
				<DeliveryInstructionDetailUpload
					:openPopup="isShowPopupUploadDeliveryInstructionDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataDeliveryInstructionDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
					<app-input-textbox :id="'input-delivery-instruction-details-qty-delivery-' + row.index" label-cols-lg="12" label="Qty Delivery" size="sm" :model.sync="row.item.qtyDelivery"   @change="saveInputDeliveryInstructionDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

		<PopupPDF :openPopup="isShowPopUpPdf" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Print Delivery Instruction" />

        <b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-left-button>
			<div>
				<b-button :disabled="checkAllData.length < 1" @click="printDc(0)" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print DC</b-button>
				<b-button @click="printPdfCustom(model.id)" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print Delivery Instruction</b-button>
			</div>
		</template>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionList from '@/models/DeliveryInstruction/DeliveryInstructionList';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryOrder from '@/models/DeliveryOrder/DeliveryOrder';
import DeliveryOrderFilter from '@/filters/DeliveryOrder/DeliveryOrderFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import DeliveryInstructionStatus from '@/models/DeliveryInstructionStatus/DeliveryInstructionStatus';
import DeliveryInstructionStatusFilter from '@/filters/DeliveryInstructionStatus/DeliveryInstructionStatusFilter';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import PartDestination from '@/models/PartDestination/PartDestination';
import PartDestinationFilter from '@/filters/PartDestination/PartDestinationFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import DeliveryOrderDetail from '@/models/DeliveryOrder/DeliveryOrderDetail';
import DeliveryOrderDetailFilter from '@/filters/DeliveryOrder/DeliveryOrderDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import DeliveryInstructionDetailInput from '@/views/DeliveryInstruction/DeliveryInstructionDetailInput';
import DeliveryInstructionDetailUpload from '@/views/DeliveryInstruction/DeliveryInstructionDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		DeliveryInstructionDetailInput,DeliveryInstructionDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
		PopupPDF
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsDeliveryInstructionDetail: [
				// {"frontActions": { "class" : "th-actions", "label" : ""}},
				{"front-action": { "class" : "th-actions", "label" : ""}},
				{"printAction" : { "class" : "th-actions d-stack-none", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part first-child", "label" : "Product Code", key: 'part', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Product Name", key: 'partName', sortable: false}}, 
				{"qtyDelivery": { "class" : "th-qty-delivery last-child", "label" : "Qty Delivery", key: 'qtyDelivery', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelDeliveryInstructionDetail : {},
			isShowPopupDeliveryInstructionDetail : false,
			isShowPopupUploadDeliveryInstructionDetail : false,
			filterDeliveryInstruction : null,
			currentDeliveryInstructionPage : 1,
			deliveryInstructionPageSize: 10,
			sortByDeliveryInstruction: '',
			sortDescDeliveryInstruction: '',
			filterDeliveryInstructionDetail : null,
			currentDeliveryInstructionDetailPage : 1,
			deliveryInstructionDetailPageSize: 10,
			sortByDeliveryInstructionDetail: '',
			sortDescDeliveryInstructionDetail: '',
			sortingByDeliveryInstructionDetail: [],
			deliveryInstructionDetails : [],
			deliveryInstructionDetailId : '',
			totalDeliveryInstructionDetailRow : 0,
			isShowDeliveryInstructionDetailFilter: false,
			isDownloadDeliveryInstructionDetail: false,
			parts: [],
			deliveryOrders: [],
			isDeliveryOrderComboLoading: false,
			deliveryInstructionStatuss: [],
			diStatuss: [],
			isDiStatusComboLoading: false,
			customers: [],
			diCustomers: [],
			isDiCustomerComboLoading: false,
			partDestinations: [],
			isPartDestinationComboLoading: false,
			partDestinationState: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isDeliveryInstructionStatusComboLoading: false,
			isCustomerComboLoading: false,
			isDeliveryInstructionComboLoading: false,
			isPartComboLoading: false,
			isDeliveryOrderDetailComboLoading: false,
			isShowPopUpPdf: false,
			pdfUrl: '',
			checkAll: false,
		}
	},
	methods : {
		toggleSelectAll() {
			this.checkAll = !this.checkAll;
			if(this.checkAll) {
				if(this.deliveryInstructionDetails.length == 0) return;

				this.deliveryInstructionDetails.forEach(item => {
					console.log(item.id);
					if(!this.checkAllData.includes(Number(item.id))) {
						this.$store.dispatch("addCheckData", Number(item.id));
					}
				});
			} else {
				if(this.deliveryInstructionDetails.length == 0) return;

				this.deliveryInstructionDetails.forEach(item => {
					console.log(item.id);
					this.$store.dispatch("removeCheckData", Number(item.id))
				});
			}

			console.log("list check", this.checkAllData);
		},
		toggleSelect(id) {
			console.log("id on single check", id);
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		printDc: async function(detailId) {
			this.isBusy = true;
			if(detailId != 0) {
				this.$store.dispatch("removeCheckAllData")
				this.checkAllData.push(Number(detailId));
			}
			await DeliveryInstruction.printDC(this, this.checkAllData).then(result => {
				if(result.result == "OK") {
					this.$bvToast.toast("Success Printing to ZPL Printer", {
						title: 'Print DC',
						variant: 'success',
						solid: true,
						autoHideDelay: 2000 // Optional: Mengatur durasi pesan
					});

					this.isBusy = false;
				}
			})

			this.isBusy = false;
		},
		printPdfCustom: async function(id) {
			this.isShowPopUpPdf = true;
			let result = await DeliveryInstruction.printPdfCustom(this, id);
			this.pdfUrl = result.download;
		},
		getDeliveryInstruction : async function(id) {
			this.isBusy = true;
			DeliveryInstruction.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.destinationId != null) {
					promises.push(
						this.getCustomer(this.model.destinationId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDeliveryInstruction = true;
			this.filterDeliveryInstruction.id = this.modelId;
			DeliveryInstruction.downloadDataDetail(this, this.filterDeliveryInstruction).then(result => {
				this.isDownloadDeliveryInstruction = false;
			}).catch(error => { this.isDownloadDeliveryInstruction = false; })
		},
		getDeliveryInstructionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterDeliveryInstructionDetail);
			if (this.modelId == null) return;
			filter.deliveryInstructionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByDeliveryInstructionDetail != null) {
				this.sortingByDeliveryInstructionDetail[this.sortByDeliveryInstructionDetail] = this.sortDescDeliveryInstructionDetail;
			}
			let currentPage = (this.currentDeliveryInstructionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalDeliveryInstructionDetailRow + 1;
				let page = Math.ceil(totalData/this.deliveryInstructionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.deliveryInstructionDetailPageSize = 0;
			// disable paging end
			DeliveryInstructionDetail.getList(this, filter, this.sortingByDeliveryInstructionDetail, currentPage , this.deliveryInstructionDetailPageSize).then(result => {
				this.currentDeliveryInstructionDetailPage = currentPage + 1;
				this.deliveryInstructionDetails = result.data;
				this.totalDeliveryInstructionDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.DiNumber = input;
			}
			this.isDeliveryInstructionComboLoading = true;
			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
				this.isDeliveryInstructionComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			this.isDeliveryInstructionComboLoading = true;
			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
				this.isDeliveryInstructionComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryOrderDetails : async function(input) {
			let filter = new DeliveryOrderDetailFilter();
			if (input != undefined) {
				filter.poNumber = input;
			}
			this.isDeliveryOrderDetailComboLoading = true;
			DeliveryOrderDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryOrderDetails = result.data
				}
				this.isDeliveryOrderDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionStatuss : async function(input) {
			let filter = new DeliveryInstructionStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDeliveryInstructionStatusComboLoading = true;
			DeliveryInstructionStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionStatuss = result.data
				}
				this.isDeliveryInstructionStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryOrders : async function(input) {
			let filter = new DeliveryOrderFilter();
			if (input != undefined) {
				filter.doNumber = input;
			}
			DeliveryOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryOrders = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryOrder(item) {
			if(item == undefined || item == null) {
				this.model.deliveryOrderId = null;
				this.model.deliveryOrder = null;
			} else {
				this.model.deliveryOrderId = item.id;
				this.model.deliveryOrder = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDiStatus(item) {
			if(item == undefined || item == null) {
				this.model.diStatusId = null;
				this.model.diStatus = null;
			} else {
				this.model.diStatusId = item.id;
				this.model.diStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDiCustomer(item) {
			if(item == undefined || item == null) {
				this.model.diCustomerId = null;
				this.model.diCustomer = null;
			} else {
				this.model.diCustomerId = item.id;
				this.model.diCustomer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		onDiCustomerChange : async function() {
			this.model.partDestinationId = null;
			this.model.partDestination = null;

			let item = this.model.diCustomerId;
			let diCustomerObj = this.diCustomers.filter(function(customer){ return customer.id == item; });
			this.model.diCustomer = diCustomerObj.length > 0 ? diCustomerObj[0] : null;
			this.getPartDestinationByDiCustomer();
		},
		getPartDestinationByDiCustomer : async function(input) {
			this.partDestinationState = false;
			this.$forceUpdate();

			let filter = new PartDestinationFilter();
			filter.customerId = this.model.diCustomerId;
			if (input != undefined) {
				filter.code = input;
			}
			if (filter.customerId === undefined || filter.customerId === null || filter.customerId === '') {
				this.partDestinations = [];
			} else {
				PartDestination.getList(this, filter, null, 0, 10)
					.then(result => {
						this.partDestinations = [];
						if (result != null) {
							this.partDestinations = result.data
						}
					})
					.catch(error => {
						this.partDestinations = [];
					});
			}

			this.partDestinationState = true;
			this.$forceUpdate();
		},

		getPartDestinations : async function(input) {
			let filter = new PartDestinationFilter();
			if (input != undefined) {
				filter.destination = input;
			}
			PartDestination.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partDestinations = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPartDestination(item) {
			if(item == undefined || item == null) {
				this.model.partDestinationId = null;
				this.model.partDestination = null;
			} else {
				this.model.partDestinationId = item.id;
				this.model.partDestination = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDestination(item) {
			if(item == undefined || item == null) {
				this.model.destinationId = null;
				this.model.destination = null;
			} else {
				this.model.destinationId = item.id;
				this.model.destination = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getCustomer : async function(id) {
			Customer.getData(this, id).then(result => {
				this.model.destination = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.deliveryInstructionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					DeliveryInstruction.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'deliveryinstructionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					DeliveryInstruction.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'deliveryinstructionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryInstruction.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getDeliveryInstruction(id);
					});
				}
			});
		},
		onHidden() {
			this.getDeliveryInstructions();
		},
		addRowDataDeliveryInstructionDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.deliveryInstructionId =  this.modelId;
					DeliveryInstructionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getDeliveryInstructionDetails(true);
						this.isShowPopupDeliveryInstructionDetail = false;
					})
				} else {
					model.deliveryInstructionId =  this.modelId;
					DeliveryInstructionDetail.createDataDetail(this, model)
					.then(result => {
						this.getDeliveryInstructionDetails(true);
						this.isShowPopupDeliveryInstructionDetail = false;
					})
				}
			}
		},
		async editRowDataDeliveryInstructionDetail(id) {
			this.deliveryInstructionDetailId = id;
			this.isShowPopupDeliveryInstructionDetail = true; 
		},
		async deleteRowDataDeliveryInstructionDetail(id) {
			DeliveryInstructionDetail.deleteData(this, id).then(result => { this.getDeliveryInstructionDetails(); });
		},
		async resetDataDeliveryInstructionDetail() {
			this.deliveryInstructionDetailId = "";
			this.isShowPopupDeliveryInstructionDetail = true;
		},
		async addDataDeliveryInstructionDetail() {
			DeliveryInstructionDetail.createData(this, { deliveryInstructionId: this.modelId })
			.then(result => {
				this.getDeliveryInstructionDetails(true);
			})
		},
		async addFromClipboardDeliveryInstructionDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, deliveryInstructionId: this.modelId });
				});
				DeliveryInstructionDetail.addFromClipboard(this, parts).then(result => { this.getDeliveryInstructionDetails() });
			});
		},
		async replaceFromClipboardDeliveryInstructionDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, deliveryInstructionId: this.modelId });
				});
				DeliveryInstructionDetail.replaceFromClipboard(this, parts).then(result => { this.getDeliveryInstructionDetails() });
			});   
		},
		showPopupUploadDeliveryInstructionDetail() {
			if(this.deliveryInstructionDetails != null && this.deliveryInstructionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap DeliveryInstructionDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadDeliveryInstructionDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadDeliveryInstructionDetail = true;
			}
		},
		uploadDataDeliveryInstructionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadDeliveryInstructionDetail = false; 
		},
		downloadDeliveryInstructionDetail(modalEvent) {
			this.isDownloadDeliveryInstructionDetail = true;
			this.filterDeliveryInstructionDetail.deliveryInstructionId = this.modelId;
			DeliveryInstructionDetail.downloadDataDetail(this, this.filterDeliveryInstructionDetail).then(result => {
				this.isDownloadDeliveryInstructionDetail = false;
			}).catch(error => { this.isDownloadDeliveryInstructionDetail = false; })
		},
		saveInputDeliveryInstructionDetail(item) {
			if (this.deliveryInstructions != null && this.deliveryInstructions != undefined  && this.deliveryInstructions.length > 0) {
				item.deliveryInstruction = this.deliveryInstructions.find(q => q.id == item.deliveryInstructionId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.deliveryOrderDetails != null && this.deliveryOrderDetails != undefined  && this.deliveryOrderDetails.length > 0) {
				item.deliveryOrderDetail = this.deliveryOrderDetails.find(q => q.id == item.deliveryOrderDetailId);
			}
			if (this.deliveryInstructionStatuss != null && this.deliveryInstructionStatuss != undefined  && this.deliveryInstructionStatuss.length > 0) {
				item.deliveryInstructionStatus = this.deliveryInstructionStatuss.find(q => q.id == item.deliveryInstructionStatusId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryInstructionDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadDeliveryInstructionDetail = false; 
			this.isShowPopUpPdf = false;
			this.isShowPopupDeliveryInstructionDetail = false; 
			if (modalType == 'DeliveryInstructionDetail') {
				this.getDeliveryInstructionDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowDeliveryInstructionDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterDeliveryInstruction = new DeliveryInstructionFilter();
		this.filterDeliveryInstructionDetail = new DeliveryInstructionDetailFilter();
		//this.getDeliveryInstructions();
		//this.getParts();
		//this.getDeliveryOrderDetails();
		//this.getDeliveryInstructionStatuss();
		//this.getDeliveryOrders();
		//this.getCustomers();
		//this.getPartDestinations();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDeliveryInstruction(id);
			} else {
				this.modelId = id;
				this.getDeliveryInstruction(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		},
		checkAllData() {
			return this.$store.state.dataIds;
		}
	},
	watch : {
		sortByDeliveryInstructionDetail : {
			handler: function() {
				this.getDeliveryInstructionDetails();
			}
		},
		sortDescDeliveryInstructionDetail: {
			handler: function() {
				this.getDeliveryInstructionDetails();
			}
		},
		currentDeliveryInstructionDetailPage: {
			handler: function() {
				this.getDeliveryInstructionDetails();
			}
		},
		deliveryInstructionDetailPageSize : {
			handler: function() {
				this.getDeliveryInstructionDetails();
			}
		},
		filterDeliveryInstructionDetail: {
			handler: function() {
				this.getDeliveryInstructionDetails();
			},
			deep: true,
		},
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
